import { render, staticRenderFns } from "./elemento.vue?vue&type=template&id=7d2dd80a&"
import script from "./elemento.vue?vue&type=script&lang=js&"
export * from "./elemento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports